export class Blf {
    public lineKey: number;
    public lineEntry: number;
    public type: number;
    public label: string;
    public value: string;
}
